import styled, { css } from 'styled-components';

import { COLORS } from '@theme/colors';
import { media } from '@theme/media';
import { FONT_WEIGHT, LETTER_SPACING } from '@theme/font';

export const SortContainer = styled.div`
  ${media.tablet} {
    margin-bottom: 0;
    border-top: 1px solid ${COLORS.BLACK};
    display: grid;
    grid-template-columns: 132px 1fr;
    padding-top: 9px;
  }
`;

export const SortOptionsContainer = styled.div<{ isExpanded: boolean }>`
  position: relative;
  border-bottom: 1px solid ${COLORS.BLACK};
  overflow: auto;
  display: ${({ isExpanded }) => (isExpanded ? 'flex' : 'none')};
  flex-direction: column;
  align-items: flex-start;

  ${media.mobile} {
    border-bottom: none;
  }
`;

const getActiveStyles = css<{ active?: boolean }>`
  pointer-events: ${({ active }) => (active ? 'none' : 'auto')};
  ${({ active }) =>
    active &&
    css`
      &::after {
        content: '';
        width: 10px;
        height: 10px;
        background: ${COLORS.BLACK};
        border-radius: 50%;
        position: absolute;
        right: 4px;
        top: 50%;
        transform: translateY(-50%);
      }
    `}
`;

export const SortButton = styled.button<{ active?: boolean }>`
  ${getActiveStyles};
  padding: 0;
  line-height: 18px;
  letter-spacing: ${LETTER_SPACING.S};
  position: relative;
  width: 100%;
  text-align: left;
  font-weight: ${FONT_WEIGHT.BOOK};
  padding: 13px 0 7px;

  &:not(:last-child) {
    border-bottom: 1px solid black;
  }

  ${media.mobile} {
    &:not(:last-child) {
      border-bottom: none;
    }
    margin: 0 0 9px;
    padding: 0;
  }
`;

const optionIconStyles = css`
  content: '';
  background-color: ${COLORS.BLACK};
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
`;

export const LabelButton = styled.button<{ isExpanded: boolean }>`
  padding: 23px 0 20px;
  position: relative;
  display: flex;
  width: 100%;
  border-bottom: 1px solid ${COLORS.BLACK};

  &::after {
    ${optionIconStyles};
    width: 7px;
    height: 1px;
  }

  &::before {
    ${optionIconStyles};
    width: 1px;
    height: 7px;
    right: 8px;
    display: ${({ isExpanded }: { isExpanded: boolean }) => (isExpanded ? 'none' : 'block')};
  }

  ${media.mobile} {
    border-bottom: none;
    padding: 0;
    &::after,
    &::before {
      display: none;
    }
  }
`;
